module.exports = __webpack_public_path__ + "static/img/patternbg.4ad0eebc.svg";